"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitialValue = function (metricValues) {
    if (metricValues && metricValues.length) {
        return metricValues[metricValues.length - 1];
    }
    else {
        // TODO: We will want to be better at handling no data.
        return { timestamp: new Date(), measure: 0 };
    }
};
//# sourceMappingURL=engine.js.map